export default __webpack_public_path__ + "static/media/download-circle-black.36d075e7.svg";